import { createPinia } from 'pinia'
import { setupLayouts } from 'virtual:generated-layouts'
import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import { routes } from 'vue-router/auto-routes'

import App from './App.vue'
import i18n from './locales'
import { useUserStore } from './stores/user'

import './style.css'
import './assets/index.css'
import 'virtual:uno.css'
import '@unocss/reset/normalize.css'
import '@unocss/reset/tailwind.css'
import 'vue-sonner/style.css'

const router = createRouter({
  history: createWebHistory(),
  routes: setupLayouts(routes),
})

const pinia = createPinia()

const app = createApp(App)

app.use(pinia)
app.use(router)
app.use(i18n)

// Set up navigation guard after pinia is installed
router.beforeEach((to, from, next) => {
  const userStore = useUserStore()
  const isPublicRoute = to.meta?.public === true

  // Allow access to public routes (like login page)
  if (isPublicRoute) {
    next()
    return
  }

  // Check if user is authenticated
  if (!userStore.isAuthenticated) {
    // Redirect to login page with redirect query parameter
    next({
      path: '/login',
      query: { redirect: to.fullPath },
    })
    return
  }

  next()
})

app.mount('#app')
